import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {
    DomSanitizer,
    SafeUrl,
} from '@angular/platform-browser';
import {
    NgxDropzoneModule,
    NgxDropzonePreviewComponent,
} from 'ngx-dropzone';

@Component({
    selector: 'eb-dropzone-image-preview',
    templateUrl: './dropzone-image-preview.component.html',
    styleUrls: ['./dropzone-image-preview.component.scss'],
    providers: [
        {
            provide: NgxDropzonePreviewComponent,
            useExisting: DropzoneImagePreviewComponent,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxDropzoneModule]
})
export class DropzoneImagePreviewComponent extends NgxDropzonePreviewComponent implements OnInit, OnDestroy {
    private cd = inject(ChangeDetectorRef);

    /** The image data source. */
    public defaultImgLoading = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiByZ2IoMjQxLCAyNDIsIDI0Mykgbm9uZSByZXBlYXQgc2Nyb2xsIDAlIDAlOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjIyNHB4IiBoZWlnaHQ9IjIyNHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiPgo8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIxNCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2U9IiM4NWEyYjYiIHN0cm9rZS1kYXNoYXJyYXk9IjIxLjk5MTE0ODU3NTEyODU1MiAyMS45OTExNDg1NzUxMjg1NTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+CiAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGR1cj0iMS4xNjI3OTA2OTc2NzQ0MTg0cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGtleVRpbWVzPSIwOzEiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjEwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZT0iI2JiY2VkZCIgc3Ryb2tlLWRhc2hhcnJheT0iMTUuNzA3OTYzMjY3OTQ4OTY2IDE1LjcwNzk2MzI2Nzk0ODk2NiIgc3Ryb2tlLWRhc2hvZmZzZXQ9IjE1LjcwNzk2MzI2Nzk0ODk2NiIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgZHVyPSIxLjE2Mjc5MDY5NzY3NDQxODRzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIga2V5VGltZXM9IjA7MSIgdmFsdWVzPSIwIDUwIDUwOy0zNjAgNTAgNTAiPjwvYW5pbWF0ZVRyYW5zZm9ybT4KPC9jaXJjbGU+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==';

    public imageSrc: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(this.defaultImgLoading);
    private timeoutRef: any;

    constructor() {
        const sanitizer = inject(DomSanitizer);

        super(sanitizer);
    }

  /** The file to preview. */
  @Input()
    set file(value: File) {
        this._file = value;
        this.renderImage();
    }

  get file(): File { return this._file; }

  ngOnInit() {
      this.renderImage();
  }

  private renderImage() {
      this.readFile()
          .then((img) => {
              this.timeoutRef = setTimeout(() => {
                  this.imageSrc = img;
                  this.cd.markForCheck();
              });
              return this.timeoutRef;
          })

          .catch((err) => console.error(err));
  }

    ngOnDestroy(): void {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
    }
}
